module.exports = __webpack_public_path__ + "static/media/bg.08002bf8.wav";